var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2306 2.5202C10.0769 2.46893 9.93594 2.46893 9.80782 2.5202L1.85125 5.44294L10 8.63487L18.1488 5.44294L10.2306 2.5202ZM1.39 16.0186C1.41563 16.275 1.55657 16.4673 1.81282 16.5955L9.385 19.3644V9.71167L1.39 6.55819V16.0186ZM10.615 19.3644L18.2256 16.5955C18.4563 16.4673 18.5844 16.275 18.61 16.0186V6.55819L10.615 9.71167V19.3644ZM9.385 1.36649C9.795 1.21266 10.2178 1.21266 10.6534 1.36649L18.6484 4.28923C19.3916 4.62252 19.7888 5.19938 19.84 6.01979V16.0186C19.7888 16.839 19.3916 17.4159 18.6484 17.7492L10.6534 20.6719C10.2178 20.8257 9.795 20.8257 9.385 20.6719L1.39 17.7492C0.621254 17.4159 0.211254 16.839 0.160004 16.0186V6.01979C0.211254 5.19938 0.621254 4.62252 1.39 4.28923L9.385 1.36649Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.68,
    height: 21,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.160004 21.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.7374c9860d369a91f71c963cea35cf46.svg";
export { ForwardRef as ReactComponent };